import { Search } from './search.model';

interface FacetSearchProp {
  searchBody?: Search | null;
  sort?: string;
  page?: number;
  size?: number;
}

export class FacetSearch {
  public searchBody?: Search | null;
  public sort?: string;
  public page?: number;
  public size?: number;

  constructor({ sort, page, size, searchBody }: FacetSearchProp) {
    this.sort = sort || 'recent';
    this.page = page || 0;
    this.size = size || 50;
    this.searchBody = searchBody || null;
  }
}
